<div
    class='flex flex-col-reverse lg:flex-row'
>
    <!-- Image selector -->
    <div
        class='hidden mt-6 w-full max-w-2xl mx-auto sm:block lg:max-w-none lg:w-40 lg:mt-0'
        *ngIf='1 < assetsAndVideos.length'
    >
        <div
            class='thumbs-row relative grid gap-6 lg:grid-cols-1 lg:overflow-y-auto lg:max-h-50vh lg:px-2 lg:py-1 lg:gap-2 transition-opacity'
            [ngClass]="{
                'grid-cols-4': assets.length < 9,
                'grid-cols-8': assets.length >= 9,
                'opacity-20': isLoadingAsset$ | async,
            }"
            aria-orientation='horizontal'
            role='tablist'
        >
            <ng-container *ngFor='let item of assetsAndVideos; index as i'>
                <button
                    *ngIf='!isVideoId(item); else videoButton'
                    [id]="'tabs-1-tab-' + i"
                    [attr.data-asset-id]='item.id'
                    (click)='selectItem(item)'
                    class='relative bg-white rounded-sm flex items-center justify-center text-sm font-medium uppercase text-gray-900 cursor-pointer hover:bg-gray-50 focus:outline-none focus:ring focus:ring-opacity-50'
                    [ngClass]="{
                        'ring ring-opacity-50 ring-primary-500': selectedAsset?.id === item.id,
                        'h-24': assets.length < 9,
                        'h-12 lg:h-28': assets.length >= 9
                    }"
                    aria-controls='tabs-1-panel-1'
                    role='tab'
                    type='button'
                >
                    <span class='sr-only'> Alternate view </span>
                    <span class='absolute inset-0 rounded-sm overflow-hidden'>
                        <kb-picture
                            [src]="item.preview + '?w=140'"
                            [focalPoint]='item.focalPoint'
                            [alt]='"Thumbnail " + (i + 1) + " of " + (productName ?? "the product")'
                            imgClass='w-full h-full object-center object-cover'
                        ></kb-picture>
                    </span>
                    <span
                        class='ring-transparent absolute inset-0 rounded-sm ring-2 ring-offset-2 pointer-events-none'
                        aria-hidden='true'
                    ></span>
                </button>

                <ng-template #videoButton>
                    <button
                        [id]="'tabs-1-tab-v-' + i"
                        [attr.data-asset-id]='item'
                        (click)='selectItem(item)'
                        class='relative h-24 bg-white rounded-sm flex items-center justify-center text-sm font-medium uppercase text-gray-900 cursor-pointer hover:bg-gray-50 focus:outline-none focus:ring focus:ring-offset-2 focus:ring-opacity-50'
                        [ngClass]="{
                            'ring ring-offset-2 ring-opacity-50 ring-primary-500': selectedItem === item,
                            'h-24': assets.length < 9,
                            'h-12 lg:h-28': assets.length >= 9
                        }"
                        aria-controls='tabs-1-panel-1'
                        role='tab'
                        type='button'
                    >
                        <span class='sr-only'> Video </span>
                        <span class='absolute inset-0 rounded-sm overflow-hidden'>
                            <img
                                [src]="'https://img.youtube.com/vi/' + item + '/default.jpg'"
                                alt='Video thumbnail'
                                class='w-full h-full object-center object-cover'
                            />
                            <div
                                class='absolute top-0 w-full h-full object-center object-cover flex items-center justify-center bg-white bg-opacity-50 hover:bg-opacity-0 transition-opacity'
                            >
                                <fa-icon [icon]='playCircle' size='3x' class='text-primary-700'></fa-icon>
                            </div>
                        </span>
                        <span
                            class='ring-transparent absolute inset-0 rounded-sm ring-2 ring-offset-2 pointer-events-none'
                            aria-hidden='true'
                        ></span>
                    </button>
                </ng-template>
            </ng-container>
        </div>
    </div>
    <div class='sm:hidden flex flex-wrap justify-center' *ngIf='1 < assetsAndVideos.length'>
        <div *ngFor='let item of assetsAndVideos'>
            <button
                class='w-4 h-4 m-2 rounded-full border transition-colors'
                [ngClass]="{
                    'bg-primary-400': selectedItem === item,
                    'bg-gray-300': selectedItem !== item
                }"
                (click)='selectItem(item)'
            ></button>
        </div>
    </div>
    <div
        class='relative min-h-40vh lg:min-h-50vh lg:max-h-50vh flex items-center justify-center bg-white border rounded-sm w-full aspect-w-1 aspect-h-1'
        [ngClass]="{
            'bg-white': selectedAsset || assetsAndVideos.length === 0,
            'bg-black': !selectedAsset && assetsAndVideos.length > 0
        }"
    >
        <!-- Tab panel, show/hide based on tab state. -->
        <div
            id='tabs-1-panel-1'
            *ngIf='selectedAsset'
            (click)='openImage(selectedAsset.id)'
            class='h-full object-center object-cover max-w-xl'
            [class.w-full]='!selectedAssetIsTall'
            aria-labelledby='tabs-1-tab-1'
            role='tabpanel'
            tabindex='0'
        >
            <a
                [attr.data-pswp-src]="selectedAsset.preview + '?preset=medium'"
                [attr.data-pswp-width]='selectedAsset.width'
                [attr.data-pswp-height]='selectedAsset.height'
            >
                <kb-picture
                    [src]="selectedAsset.preview"
                    [class.opacity-20]="isLoadingAsset$ | async"
                    [focalPoint]='selectedAsset.focalPoint'
                    preset='medium'
                    class='h-full transition-opacity'
                    #mainPreview
                    (imageLoad)='imageLoaded(selectedAsset)'
                    [alt]='"Image of " + (productName ?? "the current product")'
                    imgClass='mx-auto w-full object-center object-cover cursor-pointer sm:rounded-sm max-h-50vh'
                ></kb-picture>
            </a>
        </div>
        <div
            id='tabs-1-panel-2'
            *ngIf='selectedVideoUrl'
            aria-labelledby='tabs-1-tab-2'
            class='w-full'
            role='tabpanel'
            tabindex='0'
        >
            <div
                #mainPreview
                class='video-container w-full h-full object-center object-cover sm:rounded-sm cursor-pointer'
            >
                <iframe width='640' height='360' frameborder='0' [src]='selectedVideoUrl' allowfullscreen></iframe>
            </div>
        </div>
        <div *ngIf='assetsAndVideos.length === 0' class='flex items-center justify-center'>
            <fa-icon [icon]='image' [size]='"6x"' class='text-gray-300'></fa-icon>
        </div>
        <button
            *ngIf='1 < assetsAndVideos.length'
            class='absolute left-0 top-0 bottom-0 w-12 opacity-50 bg-gradient-to-r from-white to-transparent hover:text-gray-600'
            (click)='previousImage()'
        >
            <fa-icon [icon]='chevronLeft' size='2x'></fa-icon>
        </button>
        <button
            *ngIf='1 < assetsAndVideos.length'
            class='absolute right-0 top-0 bottom-0 w-12 opacity-50 bg-gradient-to-l from-white to-transparent hover:text-gray-600'
            (click)='nextImage()'
        >
            <fa-icon [icon]='chevronRight' size='2x'></fa-icon>
        </button>
    </div>
</div>

<div class='pswp' tabindex='-1' role='dialog' aria-hidden='true' #photoswipeModal></div>
